<template>
  <div id="footer">
    <div class="content">
      <div class="logo">
        <div class="left">
          <div class="line">
            <img class="resentImg" src="../assets/img/xinshen.png" alt="logo图" style="margin-bottom: 30px">
            <p>{{ $t('footer.foo') }}</p>
            <p>(0571) 8509 9872</p>
            <p>selina.liao@sincermemo.com</p>
          </div>
          <img v-if="false" src="../../src/assets/spec/wm.png" alt="">
        </div>

        <div class="right">
          <div class="line">

          </div>
          <div class="line">
            <p @click="toJump('/software/big')">{{ $t('navbar.center') }}</p>
            <ul>
              <li @click="$router.push(item.route)" v-for="(item, index) in Productlist" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
          <div class="line">
            <p @click="toJump('/companyintroduction')">{{ $t('navbar.about') }}</p>
            <ul>
              <li @click="$router.push(item.route)" v-for="(item, index) in aboutList" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
          <div class="line">
            <p @click="toJump('/contactus')">{{ $t('navbar.advanced') }}</p>
          </div>
        </div>

        <div class="hengxian">

        </div>

        <div class="business">
          <div>
            <div class="name">{{ $t('footer.foo1') }}</div>
            <div class="phone">{{ $t('footer.foo2') }}：18457159182</div>
            <div class="phone">{{ $t('footer.foo3') }}：selina.liao@sincermemo.com</div>
          </div>
          <div style="margin-top: 25px;">
            <div class="name">{{ $t('footer.foo4') }}</div>
            <div class="phone">{{ $t('footer.foo2') }}：19016980121</div>
            <div class="phone">{{ $t('footer.foo3') }}：allenlu@sincermemo.com</div>
          </div>
        </div>
      </div>
    </div>

    <div class="CopyrightInformation">
      <div class="bottom">
        <p class="copyrigh">
          <span>Copyrigh © 2024 {{ $t("introduction.line") }}</span>
          <span @click="jump()" style="cursor: pointer;">
            <a>浙ICP备2024139724号</a>
          </span>
          <span class="beian">
            <img class="resentImg" src="../assets/img/copyrigh.png" alt="logo图" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33011302000849" rel="noreferrer"
              target="_blank">浙公网安备33011302000849号</a>
          </span>

        </p>
      </div>
    </div>
  </div>

</template>
<script>
import i18n from "../lang";
export default {
  name: "Footer",
  data() {
    return {
      ds: 1,
    };
  },
  computed: {
    counter() {
      return i18n.locale;
    },
    Productlist() {
      return [
        {
          title: this.$t('prod.save'),
          route: '/software/big'
        },
        {
          title: this.$t('prod.fz'),
          route: '/software/big'
        },
      ]
    },
    aboutList() {
      return []
      return [
        {
          title: this.$t('aboutList.ab1'),
          route: '/companyintroduction'
        },
        {
          title: this.$t('aboutList.ab3'),
          route: '/core'
        },
        {
          title: this.$t('aboutList.ab4'),
          route: '/Classic'
        },
        {
          title: this.$t('aboutList.ab5'),
          route: '/news'
        },
        {
          title: this.$t('aboutList.ab8'),
          route: '/contactus'
        },
      ]
    }
  },
  watch: {
    // 如果你还需要在cut变化时执行某些操作，可以监视cut
    counter(newVal, oldVal) {
      // 当cut的值变化时，执行的操作
      console.log(newVal);
      if (newVal === "zh") {
        this.ds = 1;
      } else {
        this.ds = 0;
      }
    },
  },
  created() {
    console.log("当前页面获取的", i18n.locale);
    const id = i18n.locale;
    if (id === "zh") {
      this.ds = 1;
    } else {
      this.ds = 0;
    }
  },
  methods: {
    jump() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index');
    },
    toJump(url) {
      this.$router.push(url)
    }
  }
};
</script>
<style scoped>
.hengxian {
  width: 1px;
  height: 196px;
  background: #D8D8D8;
  margin-right: 100px;
}

.CopyrightInformation {
  width: 100%;
  height: 70px;
  line-height: 70px;
  background: #E2E2E2;
}

.CopyrightInformation p {
  width: 1170px;
  margin: 0 auto;
  text-align: center;
}

.business .name {
  font-weight: 500;
  font-size: 14px;
  color: #242933;
  margin-bottom: 10px;
}

.business .phone {
  margin-bottom: 10px;
}

#footer {
  width: 100%;
  height: auto;
  color: #575757;
  background: #F2F2F2;
  overflow: hidden;
}

#footer .content {
  width: 1170px;
  margin: 0 auto;
}

#footer .content .left .line p {
  margin-bottom: 20px;
  cursor: pointer;
}

#footer .content .right {
  display: flex;
  justify-content: space-between;
}

#footer .content .right .line {
  margin-right: 50px;
}

#footer .content .right .line p {
  font-weight: 400;
  font-size: 16px;
  color: #242933;
  line-height: 22px;
  cursor: pointer;
  margin-bottom: 32px;
}

#footer .content .right .line li {
  cursor: pointer;
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 16px;
  color: #575757;
  line-height: 22px;
}

.resentImg {
  width: 179px;
  height: 35px;
}

.logo {
  display: flex;
  justify-content: flex-start;
  padding: 50px 0;
  margin: 0 auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.bottom {
  margin-top: 20px;
  flex: 1;
  height: 70px;
  line-height: 70px;
  background: #E2E2E2;
}

.bottom p {
  height: 100%;
  display: flex;
  align-items: center;
  color: #575757;
  justify-content: center;
}

.bottom p span {
  padding-left: 20px;
}

@media screen and (max-width: 1170px) {
  #footer {
    height: auto;
  }

  #footer .content {
    width: 100%;
  }

  #footer .left img {
    margin: 0 auto;
  }

  #footer .left .line {
    margin: 0 auto;
    text-align: center;
  }

  #footer .right {
    display: none !important;
  }

  #footer .logo {
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 997px) {
  #footer {
    height: auto;
  }

  #footer .right {
    display: none !important;
  }

  .bottom p {
    height: 100%;
    display: flex;
    align-items: center;
    color: #575757;
    font-size: 1.2rem;
    justify-content: normal;
  }

  .bottom p span {
    padding-left: 20px;
  }
}

.copyrigh {
  white-space: pre-wrap;

}

.copyrigh img {
  width: 15px;
  height: 15px;
}

.beian {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue